import { IPrices, IPrice } from '../../../../common/model/IPrice';
import { IPriceDisplay } from '../model/IPlatformConfig';
import { DealPriceType } from '../../../../common/enum/DealPriceType';

const dealPriceAccessor = {
  // TODO: Unify with other price services
  getFittedPrice: (prices: IPrice[]): IPrice => {
    return prices.find((price: IPrice) => price.type === DealPriceType.FITTED);
  },

  getPrimaryPrice: (prices: IPrices, priceDisplay: IPriceDisplay): IPrice => {
    return prices?.find(
      price =>
        price?.currency === priceDisplay.primary?.currency &&
        (price.type === priceDisplay.primary.type || price.type === DealPriceType.FITTED),
    ) as IPrice;
  },

  getSecondaryPrice: (prices: IPrices, priceDisplay: IPriceDisplay): IPrice => {
    return prices?.find(
      price =>
        price?.currency === priceDisplay.secondary?.currency &&
        (price.type === DealPriceType.SECONDARY || price.type === DealPriceType.FITTED),
    ) as IPrice;
  },

  isMultiCurrency(priceDisplay: IPriceDisplay): boolean {
    return (
      dealPriceAccessor.hasSecondaryCurrency(priceDisplay) &&
      priceDisplay.primary?.currency !== priceDisplay.secondary?.currency
    );
  },

  // @TODO This has nothing to do with deal. Factor out to avoid unnecessary coupling.
  hasSecondaryCurrency(priceDisplay: IPriceDisplay): boolean {
    return !!priceDisplay?.secondary;
  },

  getTotalPrice: (prices: IPrices, priceDisplay: IPriceDisplay): IPrice => {
    return prices?.find(price => {
      if (dealPriceAccessor.hasSecondaryCurrency(priceDisplay)) {
        return price.currency === priceDisplay.primary?.currency && price.type === DealPriceType.VEHICLE_TOTAL;
      }

      return price?.type === DealPriceType.VEHICLE_TOTAL;
    }) as IPrice;
  },

  getSecondaryTotalPrice: (prices: IPrices, priceDisplay: IPriceDisplay): IPrice => {
    return prices?.find(price => {
      if (dealPriceAccessor.isMultiCurrency(priceDisplay)) {
        return price.currency === priceDisplay.secondary?.currency && price.type === DealPriceType.VEHICLE_TOTAL;
      }

      return price?.type === DealPriceType.VEHICLE_TOTAL;
    }) as IPrice;
  },
};

export default dealPriceAccessor;
